import { Button, Modal } from "antd";
import { useCallback } from "react";
import { useIntl } from "react-intl";
import type { BroadcastTableRow } from "~pages/Fixtures/BroadcastPage/types/broadcastTableRow.ts";

type Props = {
  onDelete: (row: BroadcastTableRow) => void;
  record: BroadcastTableRow;
  disabled: boolean;
};

export const DeleteBroadcastAction = ({ onDelete, record, disabled }: Props) => {
  const { formatMessage } = useIntl();
  const [modal, contextHolder] = Modal.useModal();

  const handleClick = useCallback(() => {
    modal.confirm({
      title: formatMessage({ id: "broadcast.delete" }),
      content: formatMessage({ id: "broadcast.delete.confirm" }),
      okText: formatMessage({ id: "delete" }),
      okButtonProps: { loading: false },
      onOk: () => {
        onDelete(record);
      },
    });
  }, [onDelete, formatMessage, modal, record]);

  return (
    <>
      <Button onClick={handleClick} disabled={disabled} type="text" size="small" icon={<i className="fas fa-trash-can mr-2" />} />
      {contextHolder}
    </>
  );
};
